module.exports = __webpack_public_path__ + "venezuela.svg?2d0527c8517d90532699d9b61318511b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/venezuela.svg
// module id = 338
// module chunks = 10